<template>
  <div id="header">
    <div
      class="headerBtn"
      :class="{ selHeaderBtn: this.section === 1 }"
      @click="changeSelection(1)"
    >
      <h4>Upcoming Rentals</h4>
      <div
        :class="{ selheaderBtnBottom: this.section === 1 }"
        class="headerBtnBottom"
      />
    </div>

    <div
      class="headerBtn"
      :class="{ selHeaderBtn: this.section === 2 }"
      @click="changeSelection(2)"
    >
      <h4>Currently Hosting</h4>
      <div
        :class="{ selheaderBtnBottom: this.section === 2 }"
        class="headerBtnBottom"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'RentalsHeader',
  data() {
    return {
      section: 1
    }
  },
  methods: {
    changeSelection(value) {
      this.section = value
      this.$emit('selectionChanged', value)
    }
  }
}
</script>
<style scoped>
.headerBtnBottom {
  width: 40%;
  height: 3px;
  margin-top: 10px;
  background-color: white;
}

.headerBtn {
  padding-right: 16px;
  padding-left: 16px;
  font-size: 12px;
  width: 124px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: #767675;
  cursor: pointer;
}
.selHeaderBtn {
  color: var(--rentalios-dark);
}
.selheaderBtnBottom {
  background-color: var(--rentalios-dark);
}
#headerContainer {
  min-height: 80px;
}
#header {
  background-color: white;
  height: 55px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding-right: 25px;
  padding-left: 25px;
  box-shadow: 0 4px 16px 0 rgba(43, 45, 55, 0.05);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
</style>
